class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search]');
    if (!this.input || !this.results) return;

    this.input.addEventListener('input', this.onChange.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onChange() {
    const term = this.input.value.trim();
    clearTimeout(this.timer);
    if (!term) {
      this.close();
      return;
    }
    this.timer = setTimeout(() => this.load(term), 200);
  }

  load(term) {
    const base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const url = `${base}search/suggest?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=4`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const section = html.querySelector('.predictive-search');
        this.results.innerHTML = section ? section.outerHTML : '';
        this.input.setAttribute('aria-expanded', section ? 'true' : 'false');
      })
      .catch(() => this.close());
  }

  close() {
    this.results.innerHTML = '';
    this.input.setAttribute('aria-expanded', 'false');
  }

  onFocusOut(event) {
    if (!this.contains(event.relatedTarget)) this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.input.focus();
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
